var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThickMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 4,
  viewBox: "0 0 10 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 4,
  rx: 1,
  fill: "#8E8E8E"
})));
export default SvgThickMinus;